const version = 'v1'

const apiPath = {
  GET_PORTFOLIO_LIST: `${version}/api/portfolio/list`,
  GET_PORTFOLIO_LIST_SUMMARY: `${version}/api/portfolio/list/summary`,
  GET_ORDER_LIST: `${version}/api/orders/list`,
  GET_PORTFOLIO_DETAIL: `${version}/portofolios`,
  GET_GOLD_PORTFOLIO: `${version}/public/gold/portfolios`,
  GET_GOLD_PORTFOLIO_TRX: `${version}/public/gold/transactions`,
  DOWNLOAD_GOLD_PORTFOLIO: `${version}/public/gold/portfolios/pdf`,
  DOWNLOAD_GOLD_TRANSACTIONS: `${version}/public/gold/transactions/pdf`,
  GET_PORTFOLIO_PDF: `${version}/portofolios/pdf`,
  GET_PORTFOLIO_DISTRIBUSI: `${version}/portofolios/distribusi`,
  GET_PORTFOLIO_MOVEMENT: `${version}/portofolios/pergerakan`,
  FIND_PORTFOLIO: (code: string) => `${version}/portofolios/${code}`,
  GET_REGISTER: (token: string) => `${version}/investors/detail/tmp/${token}`,
  GET_REMINDER: `${version}/reminders/upcoming`,
  POST_REMINDER: `${version}/reminders/create`,
  DELETE_REMINDER: (id: string | number) => `${version}/reminders/delete/${id}`,
  FIND_REMINDER: (id: string | number) => `${version}/reminders/get/${id}`,
  PUT_REMINDER: (id: string | number) => `${version}/reminders/update/${id}`,
  GET_TRANSACTION: `${version}/orders/mutualfunds`,
  DETAIL_TRANSACTION: (orderId: string | number) =>
    `${version}/orders/mutualfunds/${orderId}`,
  POST_SUBSCRIPTION: `${version}/orders/mutualfunds/subscription`,
  PUT_SUBSCRIPTION: (orderNo: string | number) =>
    `${version}/orders/mutualfunds/subscription/${orderNo}`,
  DOWNLOAD_TRANSACTION: `${version}/orders/mutualfunds/pdf`,
  REDEMPTION_ESTIMATE: `${version}/orders/mutualfunds/redemption/estimate`,
  REDEMPTION_PRE_CHECK: `${version}/api/orders/mutualfunds/redemption/pre-check`,
  POST_REDEMPTION: `${version}/orders/mutualfunds/redemption`,
  POST_REDEMPTION_NEW: `${version}/api/orders/mutualfunds/redemption`,
  PUT_REDEMPTION: (orderNo: string | number) =>
    `${version}/orders/mutualfunds/redemption/${orderNo}`,
  POST_REDEMPTION_OTP: (id: string | number) =>
    `${version}/orders/mutualfunds/redemption/${id}`,
  POST_RESEND_OTP: (id: string | number) =>
    `${version}/orders/mutualfunds/redemption/resend/${id}`,
  IMAGE_STORAGE: `${version}/api/storages/signURL`,
  PUBLIC_IMAGE_STORAGE: `${version}/public/storages/signURL`,
  LOGIN: `${version}/users/login`,
  LOGIN_NEW: `${version}/public/auth/login`,
  OTP_REQUEST: `${version}/otp/send-otp`,
  OTP_VERIFY: `${version}/otp/verify-otp`,
  OTP_ORDER_SEND: `${version}/api/otp/order/send`,
  OTP_ORDER_VERIFY: `${version}/api/otp/order/verify`,
  REGISTER: `${version}/investors/register`,
  GET_ACCOUNT: `${version}/api/investors/detail`,
  SET_PASSWORD: `${version}/users/set-password`,
  GET_BANK_ACCOUNT: `${version}/investors/bank`,
  GET_BANK_ACCOUNT_LIST: 'doku/v3/bank-list',
  GET_INVESTORS_BANK_LIST: `${version}/api/investors/bank/list`,
  GET_ACCOUNT_STATUS: `${version}/investors/status`,
  GET_USER_PROFILE: `${version}/investors/profile`,
  FORGOT_PASSWORD: `${version}/users/reset-password-token`,
  RESET_PASSWORD: `${version}/users/reset-password`,
  CHECK_SET_PASSWORD_TOKEN: (token: string) =>
    `${version}/public/investors/set-password/check-token?token=${token}`,
  CHANGE_PASSWORD: `${version}/users/change-password`,
  READ_FILE: `${version}/api/storages/reqFile`,
  READ_FILE_PUBLIC: `${version}/storages/reqFilePublic`,
  READ_FILE_REGISTER: `${version}/public/storages/reqFileRegister`,
  DOWNLOAD_FILE_PUBLIC: `${version}/public/storages/download`,
  GENERATE_HASH: `${version}/public/auth/generate-hash`,
  LOGOUT: `${version}/public/auth/logout`,
  USER_INSTITUTIONS: `${version}/public/auth/users/institutions`,
  USER_INSTITUTIONS_GENERATE_TOKEN: `${version}/public/auth/users/institutions/generate-token`,
  PRODUCT_LIST_PATH: `${version}/api/products/list`,
  PRODUCT_MI_LIST_PATH: `${version}/products/mi`,
  PRODUCT_COMPARE_PATH: `${version}/products/comparison`,
  PRODUCT_CHART_PATH: (code: string) => `${version}/products/chart/${code}`,
  PRODUCT_DETAIL_PATH: (code: string) => `${version}/products/detail/${code}`,
  PRODUCT_SIMULATION_PATH: (code: string) =>
    `${version}/products/simulation/${code}`,
  PRODUCT_SHOWCASE: `${version}/api/products/showcase`,
  PUBLIC_ONBOARDING_CHECK_EMAIL: `${version}/public/onboarding/check-email`,
  PUBLIC_ONBOARDING_CHECK_PHONE: `${version}/public/onboarding/check-phone`,
  PUBLIC_ONBOARDING_VERIFY_OTP: `${version}/public/onboarding/verify-otp`,
  PUBLIC_ONBOARDING_SEND_OTP: `${version}/public/onboarding/send-otp`,
  PUBLIC_ONBOARDING_CREATE_PASSWORD: `${version}/public/onboarding/create-password`,
  PUBLIC_INVESTOR_TRACKER_CLOSE: `${version}/public/investors/tracker/close`,
  PUBLIC_INVESTOR_ONBOARDING_TRACKER: `${version}/api/investors/onboarding/tracker`,
  PUBLIC_INVESTOR_POPUP_CLOSE: `${version}/api/investors/popup/close`,
  GET_SERVER_TIME: `${version}/public/server-time`,

  // GOLD
  GOLD_PRODUCTS: `${version}/api/gold/products`,
  GOLD_PRODUCT_DETAIL: (productCode: string) =>
    `${version}/api/gold/products/${productCode}`,
  GOLD_CHART: `${version}/api/gold/chart`,
  GOLD_ONBOARDING_REQUEST: `${version}/api/gold/onboarding/request`,
  GOLD_TRANSACTIONS: `${version}/api/gold/transactions`,
  GOLD_TRANSACTION_DETAIL: (orderNo: string) =>
    `${version}/api/gold/order/detail/${orderNo}`,
  GOLD_ORDER_BUY: `${version}/api/gold/order/buy`,
  GOLD_ORDER_SELL: `${version}/api/gold/order/sell`,
  GOLD_ORDER_SELL_PRE_CHECK: `${version}/api/gold/order/sell/pre-check`,
  GOLD_ORDER_SELL_PREVIEW: `${version}/api/gold/order/sell/preview`,
  /** @deprecated Estimasi tanggal cair sekarang diambil dari `estimated_completion_time` pada response GOLD_ORDER_SELL_PREVIEW. */
  GOLD_ORDER_ESTIMATED_CASHOUT_DATE: `${version}/api/gold/estimasi-dana-cair`,
  GOLD_ORDER_DOCUMENT_AGREEMENT: `${version}/api/gold/order/document-agreement`,
  GOLD_ORDER_TRANSFER_BANK: `${version}/api/gold/order/transfer/bank`,
  GOLD_PRODUCT_PERFORMANCE: (productCode: string) =>
    `${version}/api/gold/chart/performance/${productCode}`,
  GOLD_PORTFOLIOS_SYNC: `${version}/api/gold/portfolios/sync`,
  GOLD_PORTFOLIOS_DOWNLOAD_PDF: `${version}/api/gold/portfolios/pdf`,
  GOLD_TRANSACTIONS_DOWNLOAD_PDF: `${version}/api/gold/transactions/pdf`,

  // Orcrist API (apinews.bareksa.dev)
  ORCRIST_TERMS_AND_CONDITIONS: (id: string | number) =>
    `orcrist/v1/faq/legal/search/${id}`,

  // News API
  NEWS_LIST: `news/v1/list-news`,
  NEWS_POPULAR: `news/v1/news-popular`,
  NEWS_CATEGORY: (category: string) => `news/v1/home/category/${category}`
}

export default apiPath
